/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { getTokenFromFirebase } from "../../firebase.js";

const PushNotifications = (props) => {
  const [isTokenFound, setTokenFound] = useState(false);

  // To load once
  useEffect(() => {
    let data;

    async function tokenFunc() {
      data = await getTokenFromFirebase(setTokenFound);
      if (data) {
      }
      return data;
    }

    tokenFunc();
  }, [setTokenFound]);

  return <></>;
};

PushNotifications.propTypes = {};

export default PushNotifications;
